import React from 'react';

// Sway (旧クロスグラム) のプライバシーポリシー。
// Google OAuth 検証が「自社ドメインでホストされたポリシー」を要求するため、
// flycricket でホストしていた本文をそのまま swaycross.com/privacy に移設した (2026-09-01)。
// 本文の文言はアプリ内から参照している flycricket 版と同一。

const sectionStyle: React.CSSProperties = { marginTop: '32px' };
const h2Style: React.CSSProperties = { fontSize: '20px', fontWeight: 700, marginBottom: '12px' };
const pStyle: React.CSSProperties = { fontSize: '15px', lineHeight: 1.8, margin: '8px 0' };
const liStyle: React.CSSProperties = { fontSize: '15px', lineHeight: 1.8 };

const PrivacyPage = () => {
  return (
    <div style={{ backgroundColor: '#fff', color: '#222', minHeight: '100vh' }}>
      <div style={{ maxWidth: '760px', margin: '0 auto', padding: '48px 20px 80px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 700 }}>Sway (クロスグラム) Privacy Policy</h1>

        <p style={pStyle}>
          This privacy policy applies to the クロスグラム app (hereby referred to as "Application")
          for mobile devices that was created by テルパス株式会社 (hereby referred to as "Service
          Provider") as a Freemium service. This service is intended for use "AS IS".
        </p>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Information Collection and Use</h2>
          <p style={pStyle}>
            The Application collects information when you download and use it. This information may
            include information such as
          </p>
          <ul>
            <li style={liStyle}>Your device's Internet Protocol address (e.g. IP address)</li>
            <li style={liStyle}>
              The pages of the Application that you visit, the time and date of your visit, the time
              spent on those pages
            </li>
            <li style={liStyle}>The time spent on the Application</li>
            <li style={liStyle}>The operating system you use on your mobile device</li>
          </ul>
          <p style={pStyle}>
            The Application collects your device's location, which helps the Service Provider
            determine your approximate geographical location and make use of in below ways:
          </p>
          <ul>
            <li style={liStyle}>
              Geolocation Services: The Service Provider utilizes location data to provide features
              such as personalized content, relevant recommendations, and location-based services.
            </li>
            <li style={liStyle}>
              Analytics and Improvements: Aggregated and anonymized location data helps the Service
              Provider to analyze user behavior, identify trends, and improve the overall
              performance and functionality of the Application.
            </li>
            <li style={liStyle}>
              Third-Party Services: Periodically, the Service Provider may transmit anonymized
              location data to external services. These services assist them in enhancing the
              Application and optimizing their offerings.
            </li>
          </ul>
          <p style={pStyle}>
            The Service Provider may use the information you provided to contact you from time to
            time to provide you with important information, required notices and marketing
            promotions.
          </p>
          <p style={pStyle}>
            For a better experience, while using the Application, the Service Provider may require
            you to provide us with certain personally identifiable information, including but not
            limited to userid, location. The information that the Service Provider request will be
            retained by them and used as described in this privacy policy.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Third Party Access</h2>
          <p style={pStyle}>
            Only aggregated, anonymized data is periodically transmitted to external services to aid
            the Service Provider in improving the Application and their service. The Service
            Provider may share your information with third parties in the ways that are described in
            this privacy statement.
          </p>
          <p style={pStyle}>
            Please note that the Application utilizes third-party services that have their own
            Privacy Policy about handling data. Below are the links to the Privacy Policy of the
            third-party service providers used by the Application:
          </p>
          <ul>
            <li style={liStyle}>
              <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noreferrer">
                Firebase Crashlytics
              </a>
            </li>
          </ul>
          <p style={pStyle}>
            The Service Provider may disclose User Provided and Automatically Collected Information:
          </p>
          <ul>
            <li style={liStyle}>
              as required by law, such as to comply with a subpoena, or similar legal process;
            </li>
            <li style={liStyle}>
              when they believe in good faith that disclosure is necessary to protect their rights,
              protect your safety or the safety of others, investigate fraud, or respond to a
              government request;
            </li>
            <li style={liStyle}>
              with their trusted services providers who work on their behalf, do not have an
              independent use of the information we disclose to them, and have agreed to adhere to
              the rules set forth in this privacy statement.
            </li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Opt-Out Rights</h2>
          <p style={pStyle}>
            You can stop all collection of information by the Application easily by uninstalling it.
            You may use the standard uninstall processes as may be available as part of your mobile
            device or via the mobile application marketplace or network.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Data Retention Policy</h2>
          <p style={pStyle}>
            The Service Provider will retain User Provided data for as long as you use the
            Application and for a reasonable time thereafter. If you'd like them to delete User
            Provided Data that you have provided via the Application, please contact them at
            msys819@gmail.com and they will respond in a reasonable time.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Children</h2>
          <p style={pStyle}>
            The Service Provider does not use the Application to knowingly solicit data from or
            market to children under the age of 13.
          </p>
          <p style={pStyle}>
            The Application does not address anyone under the age of 13. The Service Provider does
            not knowingly collect personally identifiable information from children under 13 years
            of age. In the case the Service Provider discover that a child under 13 has provided
            personal information, the Service Provider will immediately delete this from their
            servers. If you are a parent or guardian and you are aware that your child has provided
            us with personal information, please contact the Service Provider (msys819@gmail.com) so
            that they will be able to take the necessary actions.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Security</h2>
          <p style={pStyle}>
            The Service Provider is concerned about safeguarding the confidentiality of your
            information. The Service Provider provides physical, electronic, and procedural
            safeguards to protect information the Service Provider processes and maintains.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Changes</h2>
          <p style={pStyle}>
            This Privacy Policy may be updated from time to time for any reason. The Service
            Provider will notify you of any changes to the Privacy Policy by updating this page with
            the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any
            changes, as continued use is deemed approval of all changes.
          </p>
          <p style={pStyle}>This privacy policy is effective as of 2024-07-12</p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Your Consent</h2>
          <p style={pStyle}>
            By using the Application, you are consenting to the processing of your information as
            set forth in this Privacy Policy now and as amended by us.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Contact Us</h2>
          <p style={pStyle}>
            If you have any questions regarding privacy while using the Application, or have
            questions about the practices, please contact the Service Provider via email at
            msys819@gmail.com.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPage;
